<template>
  <b-nav-item
    @click="goTo"
    class="item"
  >
    {{ username }} さん
  </b-nav-item>
</template>

<script>
export default {
  data () {
    return {
      modelName: 'nav'
    }
  },

  computed: {
    username () {
      return this.$store.getters[`${this.modelName}/username`]
    }
  },

  methods: {
    goTo () {
      this.$router.push({ name: 'user-info' })
    }
  },

  created () {
    this.$store.dispatch('user/get')
  }
}
</script>


<style lang="scss" scoped>
.item {
  font-size: 0.8rem;
}
</style>
